<h2 class="titulo" style="margin-top: -30px;">{{this.data['name']}} | Información CMF | {{this.requestDate | date: 'dd/MM/yyyy'}}
  <span *ngIf="this.hasUpdatePermission" (click)="updateSbif()" class="span_header" matTooltip="Actualizar">
    <i-tabler class="icon-20" name="refresh">
    </i-tabler>  
  </span>
</h2>
<div *ngIf="this.dataSource.data.length == 0 else tableData" style="text-align: center;">
  <h3 style="font-weight: normal;">Sin Informacion de CMF</h3>
</div>
<ng-template #tableData>
<div class="table-responsive" >
  <table mat-table [dataSource]="displayData" matSort matSortDirection="asc" class="mat-elevation-z8 demo-table">
    
    <ng-container
      [matColumnDef]="column"
      *ngFor="let column of displayedColumns; index as i"
    >
    <th mat-header-cell *matHeaderCellDef>{{ this.headers[i] }}</th>
      <!-- 
        <td mat-cell *matCellDef="let element">
          {{ element[column] | currency: 'CLP' }}
        </td></ng-container
      > -->
      <ng-container *ngIf="column == '0'">
        <th mat-cell *matCellDef="let element">
          {{ this.DebtTypeDict[element[column]] }}
        </th></ng-container
      >
      <ng-container *ngIf="column != '0'">
        <td mat-cell *matCellDef="let element">
          {{ element[column] | number}}
        </td></ng-container
      >

    </ng-container>

    

    <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>
</div>
</ng-template>